import React from 'react'
import Button from '../../../component/button/Button'
import DynamicInlineForm from '../../../component/DynamicInline/DynamicInlineForm'
import SectionContainer from '../../../Homepage/SectionContainer'
import { Col, Row } from 'reactstrap'
import Fullform from '../../../component/FullForm/Fullform'
import MediumButton from '../../../component/button/MediumButton'
import { Upload } from 'lucide-react'

const FranchiseHidden = () => {
  return (
     <SectionContainer >
        <Row style={{marginTop:"6rem"}}> 
          <Col>
            <h1 className="font-level-4 lh-1">
             REGIONAL OFFICE <br /> PARTNERSHIP APPLICATION
            </h1>
          </Col>
        </Row>

        <Fullform
          fullName={true}
          emailAddress={true}
          phoneNumber={true}
          address={true}
          priorExp={true}
          FrnExp={true}
          InsOpening={true}
          whereAbouts={true}
          localResident={true}
          plan={true}
          investor={true}
          additionalInfo={true}
          uploadBtn={true}
        />

    


        
      </SectionContainer>

  )
}

export default FranchiseHidden
